import React, { useState } from "react";
import { Box, Card, Typography, CardContent, Grid, Backdrop, TextField } from "@material-ui/core";
import "moment-timezone";
import TabHeader from "src/components/TabHeader/TabHeader";
import { useStyles } from "./style";
import CommonMaterialGrid from "src/components/CommonXGrid/CommonMaterialGrid";
import { useFormik } from "formik";
import { GridRowModel } from "@material-ui/x-grid";
import { fetchWrapper } from "src/api-client/fetchWrapper";
import { useAppSelector } from "src/app-redux/hooks";
import { loader as vehicleLoader } from "src/app-redux/vehicle/vehicleSlice";
import Drawer from "src/modules/vehicle-management/pages/ListVehicles/components/Drawer";
import CommonLoader from "src/components/Loader/CommonLoader";
import CommonAutoCompleteField from "src/components/CommonAutoCompleteField/CommonAutoCompleteField";
import { addNotificationAction } from "src/app-redux/settings/settingsSlice";
import { useDispatch } from "react-redux";
import Checkbox from "@material-ui/core/Checkbox";
import CommonButton from "src/components/CommonButton/CommonButton";
import TransitionDialog from "src/components/AlertDialog/TransitionDialog";
import { string } from "yup";

interface Props {}
interface ActionCellProps {
  row: {
    original: {
      gatePassId: number;
    };
  };
}

export function HoldUnholdContainer({}: Props): React.ReactElement {
  const isExportString = localStorage.getItem("isAllowToExportData");
  const isExport = isExportString === "true";
  const handleGatePassSelection = (gatePassId: number, checked: boolean) => {
    setSelectedGatePassIds((prev) => {
      const updated = checked ? [...prev, gatePassId] : prev.filter((id) => id !== gatePassId);

      // store as comma-separated string (or array if backend supports)
      formik.setFieldValue("gatePassIds", updated.join(","));

      return updated;
    });
  };
  const ActionCell = ({ row }: ActionCellProps) => {
    const { gatePassId } = row.original;
    const checked = selectedGatePassIds.includes(gatePassId);

    return (
      <Checkbox
        checked={checked}
        onClick={(e) => e.stopPropagation()}
        onChange={(e) => handleGatePassSelection(gatePassId, e.target.checked)}
      />
    );
  };

  ActionCell.displayName = "ActionCell";

  const classes = useStyles();

  const moduleName = "Hold/UnHold Container";
  const pageHeading = "Hold/UnHold Container(s)";
  const [gridRecord, setGridRecord] = React.useState<GridRowModel[]>([]);
  const [loader, setLoader] = useState<any>(false);
  const [virNumber, setvirNumber] = React.useState<any[]>([]);
  const [isDrawerOpen, setisDrawerOpen] = React.useState(false);
  const [virNumberLength, setVirNumberLength] = useState<number>(0);
  const loader2: any = useAppSelector(vehicleLoader);
  const dispatch = useDispatch();
  const [selectedGatePassIds, setSelectedGatePassIds] = useState<number[]>([]);
  const [isOpenConfirmationDialog, setIsOpenConfirmationDialog] = useState(false);
  const columns = React.useMemo(
    () => [
      {
        accessorKey: "action",
        header: "Hold/Unhold",
        size: 120,
        Cell: ActionCell,
      },
      {
        accessorKey: "virNumber",
        header: "Vir Number",
        size: 200,
        accessorFn: (row: any) => row.virNumber || " ",
      },
      {
        accessorKey: "containerNumber",
        header: "Container #",
        size: 200,
        accessorFn: (row: any) => row.containerNumber || " ",
      },
      {
        accessorKey: "holdBy",
        header: "Hold/Unhold By",
        size: 200,
        accessorFn: (row: any) => row.holdBy || " ",
      },
      {
        accessorKey: "holdUnHoldRemarks",
        header: "Hold/Unhold Remarks",
        size: 200,
        accessorFn: (row: any) => row.holdUnHoldRemarks || " ",
      },
    ],
    [selectedGatePassIds]
  );
  const handleCloseDrawer = () => {
    setisDrawerOpen(false);
  };
  const getvirNumber = async (virNo: string) => {
    let results: any = [];
    results = await fetchWrapper.get(`search-vir-number/${virNo}`);
    if (results.isSuccess) {
      setvirNumber(results.value.virList);
    }
    return;
  };
  const getContainerListing = async (vir: string | number) => {
    setLoader(true);
    try {
      const results = await fetchWrapper.post(`get-all-vir-containers-for-hold/${vir}`, {});

      if (results.isSuccess === true) {
        const containers = results.value?.continers || [];

        // set grid data
        setGridRecord(containers);
        const selectedIds = containers
          .filter((item: any) => item.onHold === 1)
          .map((item: any) => item.gatePassId);

        setSelectedGatePassIds(selectedIds);
        formik.setFieldValue("gatePassIds", selectedIds.join(","));
      }
    } catch (error: any) {
      dispatch(
        addNotificationAction({
          message: error.message,
          options: { variant: "error" },
        })
      );
    } finally {
      setLoader(false);
    }
  };
  const formik = useFormik({
    initialValues: {
      virNumber: "",
      gatePassIds: "",
      remarks: "",
    },
    onSubmit: async (values) => {
      if (!values.gatePassIds) {
        dispatch(
          addNotificationAction({
            message: "Please select at least one container to update.",
            options: { variant: "warning" },
          })
        );
        return;
      }
      setIsOpenConfirmationDialog(true);
    },
  });

  const handleCloseConfirmationDialog = () => {
    setIsOpenConfirmationDialog(false);
    formik.setFieldValue("remarks", "");
  };

  const handleConfirmUpdate = async () => {
    // Validate remarks before proceeding
    const remarksSchema = string()
      .required("This field is required")
      .max(3000, "Maximum 3000 characters are allowed");

    try {
      await remarksSchema.validate(formik.values.remarks);
    } catch (error: any) {
      formik.setFieldTouched("remarks", true);
      formik.setFieldError("remarks", error.message);
      return;
    }

    // Clear any previous errors
    formik.setFieldError("remarks", undefined);

    setLoader(true);
    setIsOpenConfirmationDialog(false);

    try {
      const body = {
        gatePassIds: formik.values.gatePassIds,
        remarks: formik.values.remarks,
      };
      const results = await fetchWrapper.put("update-container-hold-unhold-status", body);

      if (results.isSuccess) {
        dispatch(
          addNotificationAction({
            message: "Container status updated successfully!",
            options: { variant: "success" },
          })
        );
        if (formik.values.virNumber) {
          await getContainerListing(formik.values.virNumber);
        }
        formik.setFieldValue("remarks", "");
      } else {
        dispatch(
          addNotificationAction({
            message: results.message || "Failed to update Container status",
            options: { variant: "error" },
          })
        );
      }
    } catch (error: any) {
      dispatch(
        addNotificationAction({
          message: error.message || "Something went wrong!",
          options: { variant: "error" },
        })
      );
    } finally {
      setLoader(false);
    }
  };
  const exportHandler = async (row: any[] = []) => {
    dispatch(
      addNotificationAction({
        message: "Your download will begin shortly",
        options: { variant: "success" },
      })
    );

    const exportedRecords = await row?.map((data: any) => {
      return {
        Hold: data?.onHold === 1 ? "True" : "False",
        "Vir Number": data?.virNumber,
        "Container Number": data?.containerNumber,
        "Hold/Unhold By": data?.holdBy,
        "Hold/Unhold Remarks": data?.holdUnHoldRemarks,
      };
    });
    return exportedRecords;
  };

  return (
    <>
      <TabHeader module={moduleName} heading={pageHeading} />
      <Backdrop className={classes.backdrop} open={loader}>
        <CommonLoader />
      </Backdrop>
      {!loader2 && (
        <Drawer
          isDrawerOpen={isDrawerOpen}
          handleCloseDrawer={() => {
            handleCloseDrawer();
          }}
        />
      )}

      <Box m={2} />
      <Card>
        <CardContent className={classes.cardMain}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item md={9}>
              <Box mt={1} mb={2}>
                <Typography className={classes.pageHeading}> {pageHeading} </Typography>
              </Box>
            </Grid>
          </Grid>

          <>
            <Grid spacing={1} container direction="row" justifyContent="space-between">
              <Grid item xs={12} md={3} lg={2} style={{ paddingRight: 0 }}>
                <Box>
                  <CommonAutoCompleteField
                    cssClassName="customTextField"
                    label="VIR Number"
                    placeholder="Select VIR Number"
                    name="virNumber"
                    optionsType={virNumber}
                    getOptionLabel={(option) => option.virNo || ""}
                    required
                    value={
                      virNumber.find((st: any) => st.virNo === formik.values.virNumber) || null
                    }
                    onChange={(option: any) => {
                      formik.setFieldValue("virNumber", option.virNo);
                      formik.setFieldValue("gatePassIds", "");
                      setSelectedGatePassIds([]);
                      getContainerListing(option?.virNo);
                    }}
                    onKeyUp={(e: any) => {
                      setVirNumberLength(e.target.value.length);
                      if (e.target.value.length == 2 && virNumberLength < 2) {
                        getvirNumber(e.target.value);
                        return;
                      }
                    }}
                    onKeyDownCapture={(e: any) => {
                      if (/[^A-Za-z0-9\d]/.test(e.key)) e.preventDefault();
                      else formik.handleChange(e);
                    }}
                    onPaste={(e: any) => {
                      if (/[^A-Za-z0-9\d]/.test(e.clipboardData.getData("text"))) {
                        e.preventDefault();
                        return;
                      }

                      if (e.clipboardData.getData("text").length >= 2)
                        getvirNumber(e.clipboardData.getData("text"));
                    }}
                    error={formik.touched.virNumber && Boolean(formik.errors.virNumber)}
                    helperText={formik.touched.virNumber && formik.errors.virNumber}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={3} direction="row">
                <Box textAlign="right" mt={1} mb={1}>
                  <CommonButton
                    cssClass="customSubmitBtn"
                    isGreen
                    onClick={() => formik.handleSubmit()}
                    disable={formik.values.gatePassIds === ""}
                  >
                    Update
                  </CommonButton>
                </Box>
              </Grid>
            </Grid>
          </>
          <CommonMaterialGrid
            rows={gridRecord}
            columns={columns}
            defaultPerPageRecord={50}
            exportHandler={exportHandler}
            isExport={isExport}
            loader={loader}
            height={600}
            isFooter={true}
            filename={"Hold/Unhold Status"}
          />
        </CardContent>
      </Card>
      <TransitionDialog
        isOpen={isOpenConfirmationDialog}
        handleClose={handleCloseConfirmationDialog}
        heading={"Confirmation"}
        handleConfirm={handleConfirmUpdate}
        confirmButton="OK"
        cancelButton="Cancel"
        maxWidth="sm"
      >
        Are you sure you want to update the container hold/unhold status?
        <Box style={{ marginTop: "10px", marginBottom: "10px" }}>
          <TextField
            required
            multiline
            rows={3}
            rowsMax={5}
            size="small"
            fullWidth
            className="customTextField"
            variant="outlined"
            InputLabelProps={{
              shrink: true,
            }}
            label="Remarks"
            name="remarks"
            id="remarks"
            placeholder="Enter Remarks"
            disabled={false}
            value={formik.values.remarks}
            onChange={(e) => formik.setFieldValue("remarks", e.target.value)}
            onBlur={() => formik.setFieldTouched("remarks", true)}
            error={formik.touched.remarks && Boolean(formik.errors.remarks)}
            helperText={formik.touched.remarks && formik.errors.remarks}
          />
        </Box>
      </TransitionDialog>
    </>
  );
}
